var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      staticClass: "icon-close-lg",
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "41.028",
        height: "41.028",
        viewBox: "0 0 41.028 41.028"
      }
    },
    [
      _c(
        "g",
        {
          attrs: {
            id: "Group_662",
            "data-name": "Group 662",
            transform: "translate(1.5 1.5)"
          }
        },
        [
          _c(
            "g",
            {
              attrs: {
                id: "Path_1081",
                "data-name": "Path 1081",
                fill: "#fafafa"
              }
            },
            [
              _c("path", {
                attrs: {
                  d:
                    "M19.014,0A19.014,19.014,0,1,1,0,19.014,19.014,19.014,0,0,1,19.014,0Z",
                  stroke: "none"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M 19.0139274597168 -3.814697265625e-06 C 8.512826919555664 -3.814697265625e-06 -3.814697265625e-06 8.512826919555664 -3.814697265625e-06 19.0139274597168 C -3.814697265625e-06 29.5150260925293 8.512826919555664 38.02785873413086 19.0139274597168 38.02785873413086 C 29.5150260925293 38.02785873413086 38.02785873413086 29.5150260925293 38.02785873413086 19.0139274597168 C 38.02785873413086 8.512826919555664 29.5150260925293 -3.814697265625e-06 19.0139274597168 -3.814697265625e-06 M 19.0139274597168 -1.500003814697266 C 21.78262710571289 -1.500003814697266 24.46930694580078 -0.9574127197265625 26.99933624267578 0.1126976013183594 C 29.44229888916016 1.145988464355469 31.635986328125 2.624908447265625 33.51946640014648 4.508388519287109 C 35.40294647216797 6.391866683959961 36.88186645507812 8.58555793762207 37.91515731811523 11.02851676940918 C 38.98526763916016 13.55854797363281 39.52785873413086 16.2452278137207 39.52785873413086 19.0139274597168 C 39.52785873413086 21.78262710571289 38.98526763916016 24.46930694580078 37.91515731811523 26.99933624267578 C 36.88186645507812 29.44229888916016 35.40294647216797 31.635986328125 33.51946640014648 33.51946640014648 C 31.635986328125 35.40294647216797 29.44229888916016 36.88186645507812 26.99933624267578 37.91515731811523 C 24.46930694580078 38.98526763916016 21.78262710571289 39.52785873413086 19.0139274597168 39.52785873413086 C 16.2452278137207 39.52785873413086 13.55854797363281 38.98526763916016 11.02851676940918 37.91515731811523 C 8.58555793762207 36.88186645507812 6.391866683959961 35.40294647216797 4.508388519287109 33.51946640014648 C 2.624908447265625 31.635986328125 1.145988464355469 29.44229888916016 0.1126976013183594 26.99933624267578 C -0.9574127197265625 24.46930694580078 -1.500003814697266 21.78262710571289 -1.500003814697266 19.0139274597168 C -1.500003814697266 16.2452278137207 -0.9574127197265625 13.55854797363281 0.1126976013183594 11.02851676940918 C 1.145988464355469 8.58555793762207 2.624908447265625 6.391866683959961 4.508388519287109 4.508388519287109 C 6.391866683959961 2.624908447265625 8.58555793762207 1.145988464355469 11.02851676940918 0.1126976013183594 C 13.55854797363281 -0.9574127197265625 16.2452278137207 -1.500003814697266 19.0139274597168 -1.500003814697266 Z",
                  stroke: "none",
                  fill: "rgba(130,130,130,0.05)"
                }
              })
            ]
          ),
          _vm._v(" "),
          _c("path", {
            attrs: {
              id: "Path_719",
              "data-name": "Path 719",
              d:
                "M585.265,413.2l3.615-3.615a.749.749,0,0,0-1.06-1.06l-3.616,3.616-3.615-3.616a.749.749,0,0,0-1.06,1.06l3.616,3.615-3.616,3.616a.749.749,0,0,0,1.06,1.06l3.615-3.615,3.616,3.615a.749.749,0,0,0,1.06-1.06Z",
              transform: "translate(-565.006 -393.956)"
            }
          })
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }